/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
export type AnalyticsConsent = 'granted' | 'denied'

const GA_ID = 'G-JF5HWLRELG'
const CONSENT_STORAGE_KEY = 'analyticsConsent'

declare global {
  interface Window {
    dataLayer?: unknown[]
    // gtag signature per GA4
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    gtag?: (...args: any[]) => void
  }
}

let isInitialized = false

export const getConsent = (): AnalyticsConsent | 'unknown' => {
  const stored = localStorage.getItem(CONSENT_STORAGE_KEY)
  if (stored === 'granted' || stored === 'denied') return stored
  return 'unknown'
}

export const setConsent = (consent: AnalyticsConsent): void => {
  localStorage.setItem(CONSENT_STORAGE_KEY, consent)
  if (consent === 'granted') {
    initGA()
    // Update consent mode if gtag already available
    if (window.gtag) {
      window.gtag('consent', 'update', { analytics_storage: 'granted' })
    }
  } else {
    // Update consent mode if GA was initialized previously
    if (window.gtag) {
      window.gtag('consent', 'update', { analytics_storage: 'denied' })
    }
  }
}

const injectScript = (id: string): void => {
  if (document.getElementById('ga4-script')) return
  const script = document.createElement('script')
  script.id = 'ga4-script'
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`
  script.setAttribute('data-nscript', 'afterInteractive')
  document.head.appendChild(script)
}

export const initGA = (): void => {
  if (isInitialized) return
  if (getConsent() !== 'granted') return

  injectScript(GA_ID)

  window.dataLayer = window.dataLayer ?? []
  // Minimal gtag shim
  window.gtag = function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer?.push(arguments)
  }

  // Default to granted since we only initialize on granted
  window.gtag('js', new Date())
  window.gtag('consent', 'default', { analytics_storage: 'granted' })
  window.gtag('config', GA_ID, {
    anonymize_ip: true,
    transport_type: 'beacon',
  })
  isInitialized = true
}

export const trackPageview = (path: string): void => {
  if (!isInitialized) initGA()
  if (!window.gtag) return
  window.gtag('event', 'page_view', {
    page_path: path,
  })
}
